export default __webpack_public_path__ + "static/media/warning--accident-area--g1.a6065411.png";